import React from 'react';
import { Stack, Typography, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SectionToggle = ({ title, open, setOpen, sx, ...props }) => (
  <Stack mb={2} direction="row" alignItems="center" justifyContent="space-between" {...props}>
    <Typography sx={sx} variant="h4">
      {title}
    </Typography>
    <IconButton onClick={() => {
      setOpen(!open);
      localStorage.setItem(`${title}`, !open);
    }} size="small">
      {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </IconButton>
  </Stack>
);

export default SectionToggle;
